export { default } from './MedicationManagementPage';
